const breakpoints = {
  desktop: 1440,
  desktopSmall: 1004,
  tablet: 710,
  phoneLarge: 530,
};

export default {
  desktop: `only screen and (min-width: ${breakpoints.desktop + 1}px)`,
  desktopSmall: `only screen and (min-width: ${breakpoints.desktopSmall + 1}px)`,
  tablet: `only screen and (min-width: ${breakpoints.tablet + 1}px)`,
  phoneLarge: `only screen and (min-width: ${breakpoints.phoneLarge + 1}px)`,
};
export const breakpointsDesktopFirst = {
  desktopSmall: `only screen and (max-width: ${breakpoints.desktop}px)`,
  tablet: `only screen and (max-width: ${breakpoints.desktopSmall}px)`,
  phoneLarge: `only screen and (max-width: ${breakpoints.tablet}px)`,
  phone: `only screen and (max-width: ${breakpoints.phoneLarge}px)`,
};
